import React from 'react'

const DecorationBottomSection = () => (
  <section className="decoration-bottom full-width centered" />
)

export default DecorationBottomSection
